var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';
import { animate, flyBelow } from '@lit-labs/motion';
import { BaseComponent } from '../../utils/BaseComponent';
let TrustToast = class TrustToast extends BaseComponent {
    constructor() {
        super(...arguments);
        this.canClose = false;
        this.text = "";
        this.type = "info";
    }
    close() {
        const event = new CustomEvent('close', {
            detail: { id: this.id },
            bubbles: true,
            composed: true,
        });
        this.updateComplete.then(() => this.dispatchEvent(event));
    }
    _primaryClasses() {
        return classMap({
            ['flex items-center gap-8 group p-8 mt-16 rounded-8 border-2 w-full pointer-events-auto']: true,
            ['bg-green-50 border-green-300 text-green-800']: this.type === 'success',
            ['bg-yellow-50 border-yellow-300 text-yellow-800']: this.type === 'warning',
            ['bg-red-50 border-red-300 text-red-800']: this.type === 'error',
            ['bg-gray-50 border-gray-300 text-gray-800']: this.type === 'info',
        });
    }
    _iconClasses() {
        return classMap({
            ['flex justify-center items-center flex-shrink-0 rounded-full w-16 h-16 m-8']: true,
            ['bg-green-300']: this.type === 'success',
            ['bg-yellow-300']: this.type === 'warning',
            ['bg-red-300']: this.type === 'error',
            ['bg-gray-300']: this.type === 'info',
        });
    }
    _role() {
        return this.type === 'warning' || this.type === 'error' ? 'alert' : 'status';
    }
    _typeLabel() {
        switch (this.type) {
            case 'error': return 'Feil';
            case 'warning': return 'Varsel';
            case 'success': return 'Vellykket';
            default: return 'Info';
        }
    }
    render() {
        if (!this.text)
            return nothing;
        return html ` <section aria-label="${this._typeLabel()}"
          ${animate({ keyframeOptions: { duration: 300 }, in: flyBelow, out: flyBelow })}>
          <div class="${this._primaryClasses()}">
            <div class=${this._iconClasses()}>
              <trust-icon classNames="w-8 h-6" name="Checkmark"></trust-icon>
            </div>
            <div role="${this._role()}">
              <p>${this.text}</p>
            </div>
            ${when(this.canClose === true, () => html `<button class="ml-auto p-8" @click="${this.close}"><trust-icon classNames="w-16 h-16" name="Close"></trust-icon></button>`)}
          </div>
        </section>`;
    }
};
TrustToast.properties = {
    id: { type: String, attribute: true, reflect: true },
    type: { type: String, attribute: true, reflect: true },
};
__decorate([
    property()
], TrustToast.prototype, "classNames", void 0);
__decorate([
    property({ type: Boolean })
], TrustToast.prototype, "canClose", void 0);
__decorate([
    property()
], TrustToast.prototype, "text", void 0);
__decorate([
    property({ type: String })
], TrustToast.prototype, "type", void 0);
TrustToast = __decorate([
    customElement('trust-toast')
], TrustToast);
export { TrustToast };
//# sourceMappingURL=toast.js.map